import React from 'react';
import StrongCTA from '../components/StrongCTA';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <>
      <StrongCTA />
      <Contact />
    </>
  );
};

export default ContactPage;
